module.exports = __webpack_public_path__ + "a0863449a05c974db0f21a139c4205e0.svg";